/**
 * Smooth CSS-grid accordion for Besties product FAQ.
 * Avoids pixel-height animation that causes layout jitter with the PDP gallery.
 */
function initBestiesProductFaqAccordions(root) {
  const scope = root || document;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  scope.querySelectorAll('.besties-product-faq details.besties-product-faq__item').forEach((details) => {
    if (details.dataset.faqAccordionInit === 'true') return;

    const summary = details.querySelector('summary');
    if (!summary) return;

    details.dataset.faqAccordionInit = 'true';

    if (prefersReducedMotion) return;

    summary.addEventListener('click', (event) => {
      event.preventDefault();

      if (details.dataset.faqAnimating === 'true') return;

      if (details.classList.contains('is-open')) {
        closeFaqDetails(details);
      } else {
        openFaqDetails(details);
      }
    });
  });
}

function setFaqAnimating(details, animating) {
  if (animating) {
    details.dataset.faqAnimating = 'true';
    document.documentElement.classList.add('besties-faq-is-animating');
  } else {
    delete details.dataset.faqAnimating;
    if (!document.querySelector('.besties-product-faq details[data-faq-animating="true"]')) {
      document.documentElement.classList.remove('besties-faq-is-animating');
      document.dispatchEvent(new CustomEvent('besties:faq-animation-end'));
    }
  }
}

function waitForFaqTransition(details, callback) {
  const panel = details.querySelector('.besties-product-faq__panel');
  if (!panel) {
    callback();
    return;
  }

  const computedStyle = window.getComputedStyle(panel);
  const transitionDurations = computedStyle.transitionDuration.split(',');
  const transitionDelays = computedStyle.transitionDelay.split(',');

  const parseTimeToMs = (token) => {
    const value = token.trim();
    if (value.endsWith('ms')) return parseFloat(value) || 0;
    if (value.endsWith('s')) return (parseFloat(value) || 0) * 1000;
    return parseFloat(value) || 0;
  };

  const hasActiveTransition = transitionDurations.some((durationToken, index) => {
    const duration = parseTimeToMs(durationToken);
    const delay = parseTimeToMs(transitionDelays[index] || transitionDelays[0] || '0s');
    return duration + delay > 0;
  });

  if (!hasActiveTransition) {
    callback();
    return;
  }

  let done = false;

  const finish = () => {
    if (done) return;
    done = true;
    panel.removeEventListener('transitionend', onEnd);
    callback();
  };

  const onEnd = (event) => {
    if (event.target !== panel) return;
    finish();
  };

  panel.addEventListener('transitionend', onEnd);
  window.setTimeout(finish, 400);
}

function openFaqDetails(details) {
  const panel = details.querySelector('.besties-product-faq__panel');
  if (!panel) {
    details.open = true;
    details.classList.add('is-open');
    return;
  }

  setFaqAnimating(details, true);
  details.open = true;

  requestAnimationFrame(() => {
    details.classList.add('is-open');
    panel.style.maxHeight = `${panel.scrollHeight}px`;

    waitForFaqTransition(details, () => {
      panel.style.maxHeight = 'none';
      setFaqAnimating(details, false);
    });
  });
}

function closeFaqDetails(details) {
  const panel = details.querySelector('.besties-product-faq__panel');
  if (!panel) {
    details.open = false;
    details.classList.remove('is-open');
    return;
  }

  setFaqAnimating(details, true);
  if (panel.style.maxHeight === 'none' || !panel.style.maxHeight) {
    panel.style.maxHeight = `${panel.scrollHeight}px`;
  }

  // Force a reflow so the browser picks up the current max-height before collapsing.
  void panel.offsetHeight;
  details.classList.remove('is-open');
  panel.style.maxHeight = '0px';

  waitForFaqTransition(details, () => {
    details.open = false;
    setFaqAnimating(details, false);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initBestiesProductFaqAccordions());
} else {
  initBestiesProductFaqAccordions();
}

document.addEventListener('shopify:section:load', (event) => {
  initBestiesProductFaqAccordions(event.target);
});

document.addEventListener('shopify:block:select', (event) => {
  initBestiesProductFaqAccordions(event.target);
});
